<template>
  <div v-if="status" class="block--element notification" :class="statusClass">
    <div class="block__wrapper">
      <lennoc-icon :image="statusIcon" />
      <div class="block__content">
        <div class="text">{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseNotify',
  data () {
    return {
      statusClass: ''
    }
  },
  props: {
    message: {
      type: String,
      required: false,
      default () {
        return 'Hello World!'
      }
    },
    status: {
      type: String,
      required: false,
      default () {
        return 'ok'
      }
    }
  },
  watch: {
    status () {
      this.statusClass = `notification--${this.status}`
      switch (this.status) {
        case 'ok': return 'ok'
        case 'error': return 'error'
        case 'info': return 'info'
        case 'alert': return 'alert'
      }
      return ''
    }
  },
  computed: {
    statusIcon () {
      switch (this.status) {
        case 'ok': return 'check--large'
        case 'error': return 'warning'
        case 'info': return 'technical-tip'
        case 'alert': return 'warning'
      }
      return ''
    }
  }
}
</script>
